var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"benefits-nav-link",attrs:{"href":"/benefiti"},domProps:{"innerHTML":_vm._s(_vm.benefitsIcon)}})
}
var staticRenderFns = []

export { render, staticRenderFns }